// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const buscarNaoInteresseEmpreendimentoService = async (
  interesseId: number
) => {
  const URL = `${Globais.DOMINIOBACK}/nao-interesse-empreend/interesse/${interesseId}`;
  const Token = validateToken();

  if (Token) {
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
